// extracted by mini-css-extract-plugin
module.exports = {"close":"_40d5d0e87d--close--pb9Zo","close_button":"_40d5d0e87d--close_button--oe3c5"};